import { useQuery } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';

export const useModulesQuery = () => {
  return useQuery({
    queryFn: async () => await API.common.getModules(),
    queryKey: ['modules'],
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    initialData: [],
  });
};
